/**
 * @generated SignedSource<<d203231e6947f0d7afe4961fe1f08598>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceOverviewSwitcherQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type SpaceOverviewSwitcherQuery$data = {
  readonly confluence_smartSpaceOverview: {
    readonly faq: {
      readonly entries: ReadonlyArray<{
        readonly answer: string;
        readonly followUpQuestions: ReadonlyArray<string | null | undefined>;
        readonly question: string;
        readonly sources: ReadonlyArray<{
          readonly content: {
            readonly embeddedProduct: string | null | undefined;
            readonly excerpt: string;
            readonly id: string | null | undefined;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
          } | null | undefined;
        }>;
      }>;
    } | null | undefined;
    readonly summary: {
      readonly body: string | null | undefined;
      readonly isPinned: boolean | null | undefined;
    } | null | undefined;
    readonly topLinks: {
      readonly contentId: string | null | undefined;
      readonly lastRefreshed: AGG$DateTime | null | undefined;
      readonly links: ReadonlyArray<{
        readonly isPinned: boolean | null | undefined;
        readonly title: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SpaceOverviewSwitcherQuery = {
  response: SpaceOverviewSwitcherQuery$data;
  variables: SpaceOverviewSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "isPinned"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceSmartSpaceOverview",
    "kind": "LinkedField",
    "name": "confluence_smartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSmartSpaceOverviewSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "body"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
        "kind": "LinkedField",
        "name": "faq",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "question"
              },
              {
                "kind": "ScalarField",
                "name": "answer"
              },
              {
                "kind": "ScalarField",
                "name": "followUpQuestions"
              },
              {
                "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                "kind": "LinkedField",
                "name": "sources",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "excerpt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "embeddedProduct"
                      },
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
        "kind": "LinkedField",
        "name": "topLinks",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "kind": "ScalarField",
            "name": "lastRefreshed"
          },
          {
            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
            "kind": "LinkedField",
            "name": "links",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "url"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceOverviewSwitcherQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceOverviewSwitcherQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
    "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
    "metadata": {},
    "name": "SpaceOverviewSwitcherQuery",
    "operationKind": "query",
    "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
  }
};
})();

(node as any).hash = "1b64f396256f01419c73a81884314905";

export default node;
